export const formatMoney = (amount, decimalCount = 2, decimal = ',', thousands = '.', round = false) => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    let processedAmount;
    if (round) {
      processedAmount = Math.abs(Number(amount) || 0).toFixed(decimalCount);
    } else {
      const parts = String(amount).replace(',', '.').split('.');
      const integerPart = parts[0];
      const fractionPart = (parts[1] || '').padEnd(decimalCount, '0').slice(0, decimalCount);

      processedAmount = `${integerPart}.${fractionPart}`;
    }

    let i = parseInt(processedAmount).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
        ? decimal + processedAmount.slice(-decimalCount)
        : '')
    );
  } catch (e) {
    return '0,00';
  }
};

export default formatMoney;
